// eslint-disable-next-line import/no-unresolved
import * as CSS from "csstype";
import { IconName, IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import { LayoutProps, ResponsiveValue, SpaceProps, TLengthStyledSystem, TypographyProps } from "styled-system";
import { Flex } from "../Flex";
import { Icon } from "../Icon";

interface Props {
  icon: IconProp | "-";
  iconColor?: string;
  children: React.ReactNode;
  iconFontSize?: any;
  iconPt?: ResponsiveValue<CSS.Property.PaddingTop<TLengthStyledSystem>>;
  iconMr?: ResponsiveValue<CSS.Property.MarginRight<TLengthStyledSystem>>;
}

export const ListItem: React.FC<Props & LayoutProps & SpaceProps & TypographyProps> = ({
  icon,
  iconColor,
  iconPt,
  iconMr,
  iconFontSize,
  fontSize,
  children,
  ...props
}) => (
  <Flex as="li" alignItems="flex-start" lineHeight="small" fontSize={fontSize} data-testid="ListItem" {...props}>
    {icon !== "-" ? (
      <Icon
        mr={iconMr}
        pt={iconPt}
        mt={icon === "circle" ? "7px" : "3px"}
        fontSize={iconFontSize}
        icon={icon as IconName}
        color={iconColor}
      />
    ) : (
      "-"
    )}
    {children}
  </Flex>
);

ListItem.defaultProps = {
  fontSize: 1,
  iconMr: 2,
  iconColor: "secondary",
};
